import { render, staticRenderFns } from "./CredentialsEdit.vue?vue&type=template&id=18ca72a9&scoped=true&"
import script from "./CredentialsEdit.vue?vue&type=script&lang=js&"
export * from "./CredentialsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CredentialsEdit.vue?vue&type=style&index=0&id=18ca72a9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ca72a9",
  null
  
)

export default component.exports